export default {
  name: 'Product Name',
  edit: {
    form: 'name-input',
    label: 'Change the name',
    handler: value => value,
  },
};
